import { render, staticRenderFns } from "./History.vue?vue&type=template&id=5963131e&scoped=true&lang=pug&"
import script from "./History.vue?vue&type=script&lang=js&"
export * from "./History.vue?vue&type=script&lang=js&"
import style0 from "./History.scss?vue&type=style&index=0&id=5963131e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5963131e",
  null
  
)

export default component.exports